import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { BsArrowLeft, BsPlus } from "react-icons/bs";
import { Oval } from "react-loader-spinner";

const EditDepartamentos = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    Nombre: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getDepartamento = async () => {
      try {
        const response = await axios.get(
          `${window.BACKEND_URL}departamentos/${id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              "X-Rol": `${sessionStorage.getItem("role")}`,
            },
          }
        );
        setFormData(response.data);
      } catch (error) {
        console.error("Error al obtener el departamento:", error);
      }
    };
    getDepartamento();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      const response = await axios.put(
        `${window.BACKEND_URL}departamentos/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
            "X-Rol": `${sessionStorage.getItem("role")}`,
          },
        }
      );

      if (response.status === 200) {
        alert("Departamento actualizado correctamente");
        navigate("/departamentos");
      }
    } catch (error) {
      console.error("Error al actualizar el departamento:", error);
      alert(
        "Error al actualizar el departamento. Revisa la consola para más detalles."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/departamentos");
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title mb-0">Editar Departamento</h3>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label htmlFor="Nombre" className="form-label">
                      Nombre del departamento:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="Nombre"
                      name="Nombre"
                      value={formData.Nombre}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleBack}
                >
                  <BsArrowLeft style={{ fontSize: "1.6em" }} /> Regresar
                </button>
                <button type="submit" className="btn btn-primary">
                  {loading ? (
                    <Oval
                      color="#00BFFF"
                      height={50}
                      width={50}
                      loading={loading}
                    />
                  ) : (
                    <>
                      Editar Departamento <BsPlus style={{ fontSize: "2em" }} />
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDepartamentos;
